/* PCG Redesign — Scroll Reveal (performance-optimized) */
(function() {
  var observer = new IntersectionObserver(function(entries) {
    for (var i = 0; i < entries.length; i++) {
      if (entries[i].isIntersecting) {
        entries[i].target.classList.add('pcg-visible');
        observer.unobserve(entries[i].target);
      }
    }
    /* Auto-disconnect when all .pcg-reveal elements are visible */
    var remaining = document.querySelectorAll('.pcg-reveal:not(.pcg-visible)');
    if (remaining.length === 0) {
      observer.disconnect();
    }
  }, { threshold: 0.1 });

  function initReveal() {
    var els = document.querySelectorAll('.pcg-reveal:not(.pcg-visible)');
    for (var i = 0; i < els.length; i++) {
      observer.observe(els[i]);
    }
  }

  /* MutationObserver: pick up dynamically-added .pcg-reveal elements */
  var mutObs = new MutationObserver(function(mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if (node.classList && node.classList.contains('pcg-reveal') && !node.classList.contains('pcg-visible')) {
          observer.observe(node);
        }
        /* Also check children */
        if (node.querySelectorAll) {
          var children = node.querySelectorAll('.pcg-reveal:not(.pcg-visible)');
          for (var k = 0; k < children.length; k++) {
            observer.observe(children[k]);
          }
        }
      }
    }
  });

  /* Boot sequence */
  function boot() {
    initReveal();
    mutObs.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Re-observe on Shopify section load (theme editor + storefront ajax sections) */
  document.addEventListener('shopify:section:load', function() {
    initReveal();
  });
})();
